import { createFileRoute } from '@tanstack/react-router'
import { StaffKelembagaan } from '../../../../components/StaffKelembagaan'

export const Route = createFileRoute('/platform/desa/$desaId/kelembagaan')({
  component: () => {
    const { desaId } = Route.useParams()
    return <StaffKelembagaan desaId={desaId} />
  },
})
